
import '@/assets/scss/index.scss'

import { commonfunc } from '~/mixin/common'
import { csMixin } from '~/mixin/cs/csMixin'
export default {
  name: 'CSH0004',
  components: {
  },
  mixins: [commonfunc, csMixin],
  layout: 'DsMainLayout',
  props: {
    orderList: {
      type: Object,
      default: () => {}
    },
    searchForm: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      activeNames1: ['1'],
      activeNames2: '',
      faqDtl: [],
      faqRelatedList: [],
      isHelpComplete: false
    }
  },
  created () {
    this.selFaqDtl()
  },
  beforeMount () {
    // if (this.isNotEmpty(this.$route.params.form)) {
    //   this.searchForm = JSON.parse(this.$route.params.form)
    //   this.prevForm = JSON.parse(this.$route.params.prevForm)
    //   this.prevProdItem = JSON.parse(this.$route.params.prevProdItem)
    // }
  },
  mounted () {

  },
  methods: {
    handleChange (val) {
      console.log(val)
    },
    parsedHtml (html) {
      const parser = new DOMParser()
      const elem = parser.parseFromString(html, 'text/html')

      return elem.body.innerText
    },
    selFaqDtl () {
      this.$AxiosBuilder
        .data(this.searchForm)
        .build()
        .post('/cs/csh/faqDtl')
        .then((res) => {
          console.log(res)
          this.faqDtl = res.data.data.targetFaq
          this.faqRelatedList = res.data.data.relatedFaq
        })
    },
    goBack () {
      // this.$router.push({ name: 'cs-csh-SCR_CSH_0003', params: { prodItem: JSON.stringify(this.prevProdItem), form: JSON.stringify(this.prevForm) } })
      this.$parent.backCmpHandler('Csh0003')
    },
    goIqry () {
      const path = '/cs/csl/SCR_CSL_0001'
      this.$router.push({ path })
    },
    handleHelp (faqNo, help) {
      /* api 호출 도움 수 증가 */
      if (help) {
        const helpCntForm = {
          faqNo
        }
        this.$AxiosBuilder
          .data(helpCntForm)
          .build()
          .post('/cs/csi/updateHelpCnt')
          .then((res) => {
            console.log(res)
            this.isHelpComplete = true
          })
      } else {
        this.isHelpComplete = true
      }
    }

  }
}
